import { useMemo } from 'react';
import { useParams } from 'react-router-dom';
import { RouteParams } from 'types';

export function useNavigationPaths() {
  const { commitHash, accountSlug, brandId } = useParams<RouteParams>();

  return useMemo(() => {
    const basePrefix = commitHash
      ? `/${commitHash}/${accountSlug}`
      : `/${accountSlug}`;

    const brandSuffix = brandId ? `/${brandId}` : '';

    const homePath = `${basePrefix}${brandSuffix}`;

    return {
      homePath,
      privacyPath: `${homePath}/privacy`,
    };
  }, [commitHash, accountSlug, brandId]);
}
